import { render, staticRenderFns } from "./editMerchant.vue?vue&type=template&id=3d3741b6&"
import script from "./editMerchant.vue?vue&type=script&lang=js&"
export * from "./editMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports